import { useLanguage } from "../contexts/LanguageContext";
import { Globe } from "lucide-react";

const LanguageSwitcher = ({ variant = "default", className = "" }) => {
  const { lang, setLang } = useLanguage();
  const next = lang === "es" ? "en" : "es";

  if (variant === "compact") {
    return (
      <button
        type="button"
        data-testid="lang-switcher-compact"
        onClick={() => setLang(next)}
        className={`inline-flex items-center gap-1 px-2 py-1 rounded-full border border-white/15 bg-white/5 hover:bg-white/10 text-white/80 hover:text-[#7DD500] text-[11px] font-bold uppercase tracking-wider transition ${className}`}
        aria-label={lang === "es" ? "Cambiar a inglés" : "Switch to Spanish"}
      >
        <Globe className="w-3.5 h-3.5" />
        {next.toUpperCase()}
      </button>
    );
  }

  return (
    <div
      data-testid="lang-switcher"
      className={`inline-flex items-center rounded-full border border-white/15 bg-white/[0.04] backdrop-blur-md p-0.5 ${className}`}
    >
      {["es", "en"].map((code) => (
        <button
          key={code}
          type="button"
          data-testid={`lang-btn-${code}`}
          onClick={() => setLang(code)}
          className={`px-2.5 py-1 text-[11px] font-bold uppercase tracking-wider rounded-full transition ${
            lang === code
              ? "bg-[#7DD500] text-black"
              : "text-white/60 hover:text-white"
          }`}
        >
          {code}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
